import { Component } from '@angular/core';
import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';

declare let $: any;

@Component({
  selector: 'app-assign-modal',
  templateUrl: './assign-modal.component.html',
  styleUrls: ['./assign-modal.component.css'],
})
export class AssignModalComponent {
  trips: any = [];

  constructor(
    private gurdService: GurdServiceService,
    private otherService: OtherService,
  ) {}

  async open(unitId: string): Promise<void> {
    this.otherService.Showspinner();
    const res = JSON.parse(
      (
        await axios.post(
          `TaxiLon_Ready4Trip_ORG_List`,
          this.otherService.stringNumberToNumber({
            strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
            iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
            strUnitID: unitId,
          }),
        )
      ).data,
    );
    this.otherService.nonespinner();

    this.trips = res;
    $('#assignModal').modal('show');
  }
}
